import styled from "styled-components";

export const Container = styled.div`
  background-color: ${(props) => props.theme.background.default};
  padding: 100px 0 120px;
  @media (max-width: 1024px) {
    padding: 100px 25px 120px;
  }

  .container-history {
    background-color: ${(props) => props.theme.background.default};
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    max-width: 1080px;
    margin: 0 auto;

    .left-container {
      margin-right: 28px;
      min-width: 262px;

      /* @media (max-width: 1024px) {
        min-width: 220px;
        margin-right: 30px;
      } */

      > div {
        cursor: pointer;
        position: relative;
        width: fit-content;
        margin: 0 auto 75px;

        .nameYear {
          color: ${(props) => props.theme.color.default};
          text-decoration-line: underline;
          font-family: "Montagu Slab";
          font-style: normal;
          font-weight: 700;
          font-size: 36px;
          text-align: center;
          @media (max-width: 1024px) {
            font-size: 32px;
          }
        }

        &.title {
          font-family: "DM Sans";
          font-weight: 700;
          font-size: 24px;
          color: ${(props) => props.theme.color.default};
          text-transform: uppercase;
          margin: 0;
          margin-bottom: 65px;
        }

        .active {
          color: ${(props) => props.theme.color.active};
          font-weight: 700;
          font-size: 44px;
          margin: 80px auto 70px;
          min-width: 185px;
          @media (max-width: 1024px) {
            min-width: unset;
          }
        }

        button {
          background-color: transparent;
          &:disabled {
            opacity: 0.4;
            cursor: not-allowed;
          }

          > img {
            width: 26px;
            height: 50px;
          }

          &.prev {
            position: absolute;
            left: -20%;
            top: 3px;
            @media (max-width: 1024px) {
              left: -50%;
            }
          }

          &.next {
            position: absolute;
            right: -20%;
            top: 3px;
            @media (max-width: 1024px) {
              right: -50%;
            }
          }
        }
      }
    }

    .right-container {
      overflow-y: scroll;
      height: 832px;
      border-radius: 0 20px 20px 0;
      background-color: ${(props) => props.theme.background.white};
      width: 100%;
      padding-inline: 32px 24px;
      margin-top: 60px;
      @media (max-width: 1024px) {
        padding-inline: 24px 24px;
      }

      .item-container {
        display: flex;
        align-items: flex-start;
        padding: 22.5px 0;

        .year {
          letter-spacing: -0.03em;
          font-family: "Montagu Slab";
          font-weight: 700;
          font-size: 28px;
          color: ${(props) => props.theme.color.default};
          margin-right: 30px;
          margin-top: 60px;
        }

        .box {
          border-radius: 54.6841px;
          border: 1.2152px solid #a7a7a7;
          padding: 48px;
          width: 100%;
          position: relative;
          &::before {
            content: "";
            position: absolute;
            left: -16px;
            top: 60px;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background-color: #fff;
            border: 11px solid ${(props) => props.theme.color.default};
          }
          &--active {
            &::before {
              content: "";
              border: 11px solid ${(props) => props.theme.color.active};
            }
          }

          .item-box {
            font-family: "Noto Sans KR";
            font-weight: 700;
            font-size: 22px;
            margin-bottom: 30px;
            color: ${(props) => props.theme.color.default};
            .title {
              margin-bottom: 10px;
              &.year-active {
                color: #c52685;
              }
            }

            .content {
              padding-left: 30px;
              position: relative;
              padding-bottom: 10px;
              &:last-child {
                padding-bottom: 0;
              }
              &::before {
                content: "";
                position: absolute;
                left: 10px;
                top: 9px;
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: ${(props) => props.theme.color.default};
              }
            }

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
`;
